<div class="box sport-tree-selection">
  <app-results-events-header [timeFilterValue]="timeFilterValue"></app-results-events-header>
  <app-results-events-group [eventResults]="filteredEventResults" [scoreGroups]="evenResultsAndScoreGroups.scoreGroups"></app-results-events-group>
</div>
